



































import { Vue, Component } from "vue-property-decorator"
import api from "../honcierge-api"
import EditAnalyticsGroup from "@/components/EditAnalyticsGroup.vue"

import { DataTableHeader } from "vuetify/types"
import { AnalyticsGroup } from "types/analyticsGroup"

@Component({
  components: { EditAnalyticsGroup },
})
export default class AnalyticsGroups extends Vue {
  private loading = true
  private dialog = false
  private analyticsGroups: AnalyticsGroup["data"][] = []

  get headers(): DataTableHeader[] {
    return [
      { text: "ID", value: "id" },
      { text: "名前", value: "name" },
      { text: "Key", value: "keyName" },
      { text: "説明", value: "description" },
      { text: "操作", value: "action", sortable: false },
    ]
  }

  public created(): void {
    this.loading = false

    this.getAnalyticsGroups()
  }

  private getAnalyticsGroups() {
    api
      .getAnalyticsGroups()
      .then((res) => {
        this.analyticsGroups = res.data.analyticsGroups
      })
      .catch(() => {
        this.$toasted.error("定義一覧の取得に失敗しました")
      })
  }

  private updateAnalyticsGroup() {
    this.getAnalyticsGroups()
    this.close()
  }

  private open(item?: AnalyticsGroup["data"]) {
    const editAnalyticsGroup = this.$refs.editAnalyticsGroup as InstanceType<
      typeof EditAnalyticsGroup
    >
    if (item) {
      // 更新
      editAnalyticsGroup.id = item.id
      editAnalyticsGroup.name = item.name
      editAnalyticsGroup.keyName = item.keyName
      editAnalyticsGroup.description = item.description
    } else {
      // 新規作成
      editAnalyticsGroup.id = -1
    }

    this.dialog = true
  }

  private close() {
    this.dialog = false
  }
}
